import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: "3em",
    height: "3em",
    boxShadow: "0px 0px 10px 1px #b2b2b28f",
  },
  root: {
    maxWidth: "800px",
  },
  blogBody: {
    marginTop: "2rem",
    "& p": {
      ...theme.typography.body1,
    },
    "& h1, h2, h3, h4, h5": {
      fontSize: "1.5rem",
      marginBottom: "0",
      marginTop: "2rem",
    },
    "& a": {
      color: theme.palette.info.main,
    },
  },
}));
export default useStyles;